import styled from "@emotion/styled"
import {
  FormControl,
  InputLabel,
  NativeSelect,
  Typography,
  Select,
} from "@mui/material"

export const StyledFormControl = styled(FormControl)`
  position: relative;
  fieldset {
    border-color: black;
  }
  &.error {
    select {
      border-color: ${({ theme }) => theme.palette.text.error};
    }
    .MuiFormLabel-root {
      color: ${({ theme }) => theme.palette.text.error};
    }
    svg {
      path {
        stroke: ${({ theme }) => theme.palette.text.error};
      }
    }
  }
  &.rounded {
    .Mui-focused {
      color: ${({ theme }) => theme.palette.text.content};
    }
    .MuiNativeSelect-select {
      border-radius: 4px;
      border-color: rgba(0, 0, 0, 0.23);
      color: rgba(0, 0, 0, 0.87);
    }
    .MuiFormLabel-root {
      color: rgba(0, 0, 0, 0.54);
    }
  }
`

export const Title = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.tertiary};
  font-weight: 400;
  line-height: 100%;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.palette.text.content};
  font-size: 0.875rem;
`

export const StyledLabel = styled(InputLabel)`
  background-color: white;
  padding: 0 0.5rem;
  color: rgba(9, 20, 17, 0.8);
  margin-left: -0.25rem;
  font-family: ${({ theme }) => theme.fonts.secondary};
`

export const StyledSelect = styled(NativeSelect)`
  margin: 0 !important;
  background: #fff;
  select {
    border-radius: 4px;
    border: none;
    padding: 15.25px 14px;
    font-family: ${({ theme }) => theme.fonts.tertiary};
    color: ${({ theme }) => theme.palette.text.content};
    opacity: 0.4;
    &.MuiInputBase-inputSizeSmall {
      padding: 13.5px 14px;
    }
  }
  svg {
    right: 16px;
  }
  ::before,
  ::after {
    border-bottom: 0 !important;
  }
`

export const ErrorMessage = styled(Typography)`
  color: red;
  font-family: ${({ theme }) => theme.fonts.tertiary};
  margin-left: 14px;
  margin-top: 3px;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  text-align: left;
`
